const actions = {
  SET_STATE: 'misc/SET_STATE',
  BOTS_LIST: 'misc/BOTS_LIST',
  GET_BOT: 'misc/GET_BOT',
  ADD_BOT: 'misc/ADD_BOT',
  UPDATE_BOT: 'misc/UPDATE_BOT',
  DELETE_BOT: 'misc/DELETE_BOT',
  CHANGE_BOT_STATUS: 'misc/CHANGE_BOT_STATUS',
  BUILDER_LIST: 'misc/BUILDER_LIST',
  BUILDER_GET: 'misc/BUILDER_GET',
  BUILDER_ADD: 'misc/BUILDER_ADD',
  BUILDER_UPDATE: 'misc/BUILDER_UPDATE',
  BUILDER_RESET: 'misc/BUILDER_RESET',
  AGENT_BUILDER_LIST: 'misc/AGENT_BUILDER_LIST',
  CHAT_WIDGETS_LIST: 'misc/CHAT_WIDGETS_LIST',
  GET_CHAT_WIDGET: 'misc/GET_CHAT_WIDGET',
  ADD_CHAT_WIDGET: 'misc/ADD_CHAT_WIDGET',
  UPDATE_CHAT_WIDGET: 'misc/UPDATE_CHAT_WIDGET',
  NOTIFICATION_LOGS: 'misc/NOTIFICATION_LOGS',
  INITIATE_NOTIFICATION: 'misc/INITIATE_NOTIFICATION',
  RESET_NOTIFICATION: 'misc/RESET_NOTIFICATION',
  SHOW_INTENT_REQUEST: 'misc/SHOW_INTENT_REQUEST',
  HIDE_INTENT_REQUEST: 'misc/HIDE_INTENT_REQUEST',
  UPDATE_GET_STARTED_FEATURE_SCREEN_BEHAVIOUR: 'misc/UPDATE_GET_STARTED_FEATURE_SCREEN_BEHAVIOUR',
}

export default actions
